import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { GithubRepoCreateInput, GithubRepoCreatePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = GithubRepoCreateInput;
type TData = GithubRepoCreatePayload;

export const useGithubRepoCreate = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation githubRepoCreate($input: GithubRepoCreateInput!) {
      githubRepoCreate(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
